import Badge from "./badge";
var {
  variants,
  defaultProps
} = Badge;
var baseStyle = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm"
};
export default {
  baseStyle,
  variants,
  defaultProps
};
//# sourceMappingURL=code.js.map